import { render } from "./Key.vue?vue&type=template&id=38dbb1f8&scoped=true"
import script from "./Key.vue?vue&type=script&lang=ts"
export * from "./Key.vue?vue&type=script&lang=ts"

import "./Key.vue?vue&type=style&index=0&id=38dbb1f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-38dbb1f8"

export default script